
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {
  Code,
  ComponentDocs,
  Preview,
  md,
} from "@lighting-beetle/lighter-styleguide";
import { Addon, Input, Textarea } from "./../";
import { Button, Grid, GridCol, Icon } from "./../../";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Input`}</h1>
    <h2>{`Example`}</h2>
    <Input id="input-example" placeholder="Example input" label="Label" mdxType="Input" />
    <h2>{`Variants`}</h2>
    <h3>{`Basic`}</h3>
    <Preview mdxType="Preview">
  <Input id="input-basic" placeholder="Basic input" mdxType="Input" />
    </Preview>
    <h3>{`With label`}</h3>
    <Preview mdxType="Preview">
  <Input id="input-with-label" label="Label" placeholder="Input with label" mdxType="Input" />
    </Preview>
    <h3>{`States`}</h3>
    <Preview code={[<Input id="input-active" isActive value="Active" label="Label" mdxType="Input" />, <Input id="input-disabled" isDisabled value="Disabled" label="Label" mdxType="Input" />, <Input id="input-readonly" isReadonly value="Readonly" label="Label" mdxType="Input" />, <Input id="input-error" error value="Error" label="Label" mdxType="Input" />]} mdxType="Preview">
  <Grid mdxType="Grid">
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <Input id="input-active" isActive value="Active" label="Label" mdxType="Input" />
      <Input id="input-disabled" isDisabled value="Disabled" label="Label" mdxType="Input" />
    </GridCol>
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <Input id="input-readonly" isReadonly value="Readonly" label="Label" mdxType="Input" />
      <Input id="input-error" error value="Error" label="Label" mdxType="Input" />
    </GridCol>
  </Grid>
    </Preview>
    <h3>{`Sizes`}</h3>
    <Preview mdxType="Preview">
  <Input id="input-large" size="large" value="Large input" label="Label" mdxType="Input" />
  <Input id="input-default" value="Default input" label="Label" mdxType="Input" />
  <Input id="input-small" size="small" value="Small input" label="Label" mdxType="Input" />
    </Preview>
    <h3>{`Textarea`}</h3>
    <Preview mdxType="Preview">
  <Textarea id="textarea" rows="3" label="Label" mdxType="Textarea" />
    </Preview>
    <h3>{`Addons`}</h3>
    <Preview code={[<Input leftAddons={<Icon name="heart" mdxType="Icon" />} id="input-addons-1" mdxType="Input" />, <Input leftAddons={[<Addon className="no-pad" mdxType="Addon">
          <Button mdxType="Button">Action</Button>
        </Addon>, "Mr."]} id="input-addons-2" mdxType="Input" />, <Input rightAddons={<Icon name="heart" mdxType="Icon" />} id="input-addons-3" mdxType="Input" />, <Input leftAddons={[<Addon className="no-pad" mdxType="Addon">
          <Button mdxType="Button">Action</Button>
        </Addon>, "Mr."]} rightAddons={[".00", "€"]} id="input-addons-4" mdxType="Input" />]} mdxType="Preview">
  <Grid mdxType="Grid">
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <Input leftAddons={<Icon name="heart" mdxType="Icon" />} id="input-addons-1" mdxType="Input" />
      <Input leftAddons={[<Addon className="no-pad" mdxType="Addon">
            <Button mdxType="Button">Action</Button>
          </Addon>, "Mr."]} id="input-addons-2" mdxType="Input" />
    </GridCol>
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <Input rightAddons={<Icon name="heart" mdxType="Icon" />} id="input-addons-3" mdxType="Input" />
      <Input leftAddons={[<Addon className="no-pad" mdxType="Addon">
            <Button mdxType="Button">Action</Button>
          </Addon>, "Mr."]} rightAddons={[".00", "€"]} id="input-addons-4" mdxType="Input" />
    </GridCol>
  </Grid>
    </Preview>
    <h3>{`Addon sizes`}</h3>
    <Preview code={[<Input size="small" leftAddons={<Icon name="heart" mdxType="Icon" />} id="input-addons-size-1" mdxType="Input" />, <Input size="small" leftAddons={[<Addon className="no-pad" mdxType="Addon">
          <Button mdxType="Button">Action</Button>
        </Addon>, "Mr."]} id="input-addons-size-2" mdxType="Input" />, <Input size="large" rightAddons={<Icon name="heart" mdxType="Icon" />} id="input-addons-size-3" mdxType="Input" />, <Input size="large" leftAddons={[<Addon className="no-pad" mdxType="Addon">
          <Button mdxType="Button">Action</Button>
        </Addon>, "Mr."]} rightAddons={[".00", "€"]} id="input-addons-size-4" mdxType="Input" />]} mdxType="Preview">
  <Grid mdxType="Grid">
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <Input size="small" leftAddons={<Icon name="heart" mdxType="Icon" />} id="input-addons-size-1" mdxType="Input" />
      <Input size="small" leftAddons={[<Addon className="no-pad" mdxType="Addon">
            <Button mdxType="Button">Action</Button>
          </Addon>, "Mr."]} id="input-addons-size-2" mdxType="Input" />
    </GridCol>
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <Input size="large" rightAddons={<Icon name="heart" mdxType="Icon" />} id="input-addons-size-3" mdxType="Input" />
      <Input size="large" leftAddons={[<Addon className="no-pad" mdxType="Addon">
            <Button mdxType="Button">Action</Button>
          </Addon>, "Mr."]} rightAddons={[".00", "€"]} id="input-addons-size-4" mdxType="Input" />
    </GridCol>
  </Grid>
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<Input />" component={Input} mdxType="ComponentDocs" />
    <h2>{`Accessibility`}</h2>
    <p>{`Form inputs might seem pretty straightforward, but take extra care when dealing with labels:`}</p>
    <h3>{`Labels`}</h3>
    <h4>{`Every input needs a label`}</h4>
    <p>{`Always make sure there is a textual label associated with an input. While it might be tempting to remove labels for one-input forms such as search, each input needs it's own label that clearly describes what the user should enter.`}</p>
    <p>{`Sometimes, it might be sufficient to provide for example a search icon in the submit button and a placeholder. Sighted users will probably be able to recognize that they are dealing with a searchform - but screenreader users won't. They need a textual label for the input (can be visually hidden) and a readable submit button.`}</p>
    <h3>{`Tooltips`}</h3>
    <p>{`When using a tooltip to further describe an input, make sure the trigger is outside the `}<inlineCode parentName="p">{`<label>`}</inlineCode>{` element. Otherwise it can't be opened using a touchscreen (touching the label focuses the input element) and keyboard users won't be able to focus it (nesting focus is tricky).`}</p>
    <h3>{`Links`}</h3>
    <p>{`Links in labels have the same downsides as Tooltips. Check the section above.`}</p>
    <h3>{`Addons`}</h3>
    <p>{`When using input addons, you as the author must make sure that addons describe inputs correctly and sufficiently. `}<inlineCode parentName="p">{`aria-labelledby`}</inlineCode>{` and `}<inlineCode parentName="p">{`aria-describedby`}</inlineCode>{` work great accross screen readers and are well documented.`}</p>
    <h3>{`Further reading`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://webaim.org/techniques/forms/"
        }}>{`Creating Accessible Forms - Labels`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.w3.org/WAI/tutorials/forms/"
        }}>{`Web Accessibility Tutorials - Forms`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://formdesignpatterns.com/"
        }}>{`Form design patterns book`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.w3.org/TR/WCAG20-TECHS/ARIA9.html"
        }}>{`Using aria-labelledby to concatenate a label from several text nodes`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.w3.org/WAI/tutorials/forms/instructions/"
        }}>{`Web Accessibility Tutorials - Form Instructions`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://webaim.org/techniques/forms/advanced"
        }}>{`Creating Accessible Forms - Advanced Form Labeling`}</a></li>
    </ul>
    <h2>{`Aliases`}</h2>
    <Code inline={false} language="jsx" mdxType="Code">
  {`<Textarea /> === <Input multiline />`}
    </Code>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;